webpackJsonp([128049163870319],{

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.WorkQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  .section {\n    overflow: hidden;\n    position: relative;\n    > .gatsby-image-outer-wrapper {\n      z-index: -1;\n      position: absolute !important;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      .gatsby-image-wrapper {\n        height: 100%;\n      }\n    }\n    .container {\n      z-index: 4;\n    }\n  }\n\n  .header-content {\n    .container {\n      padding: 3rem 0;\n    }\n  }\n  .angleWrapper {\n    height: 4rem;\n    position: relative;\n    box-shadow: 5px 5px 5px #000;\n  }\n  .angle-right {\n    height: 100vh;\n    background-color: white;\n    transform: rotate(-4deg);\n    width: 180vw;\n    right: -20%;\n    top: -50%;\n    position: absolute;\n  }\n  .angle-left {\n    height: 100vh;\n    background-color: white;\n    transform: rotate(4deg);\n    width: 180vw;\n    left: -25%;\n    top: 20%;\n    position: absolute;\n  }\n  .thumbnail-wrapper {\n    border-radius: 15px;\n    overflow: hidden;\n    max-height: 600px;\n    @media screen and (min-width: 768px) {\n      margin-top: -100px;\n      margin-bottom: -200px;\n    }\n    box-shadow: 3px 3px 15px rgba(0, 0, 0, 0.2);\n  }\n\n  .content-title {\n    padding: 0 2rem;\n  }\n  .content {\n    padding: 3rem 2rem;\n    margin-bottom: 3rem;\n    line-height: 2rem;\n  }\n'], ['\n  .section {\n    overflow: hidden;\n    position: relative;\n    > .gatsby-image-outer-wrapper {\n      z-index: -1;\n      position: absolute !important;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      .gatsby-image-wrapper {\n        height: 100%;\n      }\n    }\n    .container {\n      z-index: 4;\n    }\n  }\n\n  .header-content {\n    .container {\n      padding: 3rem 0;\n    }\n  }\n  .angleWrapper {\n    height: 4rem;\n    position: relative;\n    box-shadow: 5px 5px 5px #000;\n  }\n  .angle-right {\n    height: 100vh;\n    background-color: white;\n    transform: rotate(-4deg);\n    width: 180vw;\n    right: -20%;\n    top: -50%;\n    position: absolute;\n  }\n  .angle-left {\n    height: 100vh;\n    background-color: white;\n    transform: rotate(4deg);\n    width: 180vw;\n    left: -25%;\n    top: 20%;\n    position: absolute;\n  }\n  .thumbnail-wrapper {\n    border-radius: 15px;\n    overflow: hidden;\n    max-height: 600px;\n    @media screen and (min-width: 768px) {\n      margin-top: -100px;\n      margin-bottom: -200px;\n    }\n    box-shadow: 3px 3px 15px rgba(0, 0, 0, 0.2);\n  }\n\n  .content-title {\n    padding: 0 2rem;\n  }\n  .content {\n    padding: 3rem 2rem;\n    margin-bottom: 3rem;\n    line-height: 2rem;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(11);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbySourceDatocms = __webpack_require__(20);
	
	var _Slide = __webpack_require__(49);
	
	var _Slide2 = _interopRequireDefault(_Slide);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var TemplateWrapper = _styledComponents2.default.div(_templateObject);
	
	var Work = function Work(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    TemplateWrapper,
	    null,
	    _react2.default.createElement(_gatsbySourceDatocms.HelmetDatoCms, { seo: data.datoCmsProject.seoMetaTags }),
	    _react2.default.createElement(
	      'section',
	      {
	        className: 'section is-medium ',
	        style: {
	          background: 'linear-gradient(360deg,' + data.datoCmsProject.accent.hex + ', ' + data.datoCmsProject.accent.hex + ' 15%, ' + 'transparent)'
	        }
	      },
	      _react2.default.createElement(_gatsbyImage2.default, { sizes: data.datoCmsProject.headerImage.sizes }),
	      _react2.default.createElement(
	        'div',
	        { className: 'header-content content' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'columns' },
	              _react2.default.createElement(
	                'div',
	                { className: 'column is-7' },
	                _react2.default.createElement(
	                  'h1',
	                  {
	                    className: 'title has-text-white is-size-1',
	                    style: { marginBottom: '3rem' }
	                  },
	                  'Making Our Work Matter for',
	                  ' ',
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      href: data.datoCmsProject.websiteLink,
	                      target: '_blank',
	                      style: { color: '#fff' }
	                    },
	                    _react2.default.createElement(
	                      'strong',
	                      {
	                        style: {
	                          textShadow: '2px 2px ' + data.datoCmsProject.accent.hex,
	                          borderBottom: 'solid 3px' + data.datoCmsProject.accent.hex
	                        }
	                      },
	                      data.datoCmsProject.title
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'subtitle has-text-white' },
	                  data.datoCmsProject.projectDescription
	                ),
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'button is-medium',
	                    style: {
	                      backgroundColor: data.datoCmsProject.accent.hex,
	                      borderColor: data.datoCmsProject.accent.hex,
	                      color: '#ffffff'
	                    },
	                    href: data.datoCmsProject.websiteLink,
	                    target: '_blank'
	                  },
	                  'Project Link'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'webpage-thumbnail column is-4' },
	                _react2.default.createElement(
	                  _Slide2.default,
	                  { bottom: true },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'thumbnail-wrapper' },
	                    _react2.default.createElement(
	                      'a',
	                      {
	                        href: data.datoCmsProject.websiteLink,
	                        target: '_blank',
	                        className: ''
	                      },
	                      _react2.default.createElement(_gatsbyImage2.default, {
	                        sizes: data.datoCmsProject.webpageThumbnail.sizes
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'angleWrapper' },
	        _react2.default.createElement('div', { className: 'angle-left' }),
	        _react2.default.createElement('div', { className: 'angle-right' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'columns is-multiline' },
	        _react2.default.createElement(
	          'div',
	          { className: 'content-title column is-one-third' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'title' },
	            'Background'
	          ),
	          _react2.default.createElement('hr', { style: { backgroundColor: data.datoCmsProject.accent.hex } })
	        ),
	        _react2.default.createElement('div', {
	          className: 'content column is-two-thirds',
	          dangerouslySetInnerHTML: { __html: data.datoCmsProject.background }
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'content-title column is-one-third' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'title' },
	            'Challenge'
	          ),
	          _react2.default.createElement('hr', { style: { backgroundColor: data.datoCmsProject.accent.hex } })
	        ),
	        _react2.default.createElement('div', {
	          className: 'content column is-two-thirds',
	          dangerouslySetInnerHTML: { __html: data.datoCmsProject.challenge }
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'content-title column is-one-third' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'title' },
	            'Solution'
	          ),
	          _react2.default.createElement('hr', { style: { backgroundColor: data.datoCmsProject.accent.hex } })
	        ),
	        _react2.default.createElement('div', {
	          className: 'content column is-two-thirds',
	          dangerouslySetInnerHTML: { __html: data.datoCmsProject.solution }
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'content-title column is-one-third' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'title' },
	            'Benefits'
	          ),
	          _react2.default.createElement('hr', { style: { backgroundColor: data.datoCmsProject.accent.hex } })
	        ),
	        _react2.default.createElement('div', {
	          className: 'content column is-two-thirds',
	          dangerouslySetInnerHTML: { __html: data.datoCmsProject.benefits }
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement('hr', {
	          className: 'has-background-primary',
	          style: { marginBottom: '3rem' }
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'buttons has-addons is-centered' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/work', className: 'button is-primary' },
	            '\u2190 Other Projects'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/contact', className: 'button is-primary' },
	            'Get Started \u2192'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Work;
	var WorkQuery = exports.WorkQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-work-js-0a0680ab2f2bef039d2c.js